export const api = {

    // login
    login: "admin/send_otp",
    verifyOtp: "admin/verify_otp",

    //Layouts
    getAvailableAccess: "admin/get_available_access",
    
    // Dashboard
    getDashboardStats: "admin/dashboard/stats",

    // image
    uploadImage: "upload/image",
    deleteFile: "upload/delete_file",

    // add member
    addMember: "admin/add_member",
    getMember: "admin/get_member",
    downloadMemberApplicationPdf: "admin/member/",
    getLocationByPincode: 'admin/getLocationByPincode',

    // ------------------ Settings ------------------
    getForm: "admin/form",
    createFields: "admin/fields/create",
    deleteFields: "admin/fields/delete",
    updateFields: "admin/fields/update",
    getDataById: "admin/forms_by_key",

    // Role & Permissions
    get_dynamic_role_list: "admin/get_dynamic_role_list",
    get_user_list: "admin/get_user_list",
    inactive_user_list: "admin/inactive_user_list",
    add_extra_userType: "admin/add_extra_userType",
    // delete_extra_userType: "admin/delete_extra_userType",
    active_inactive_member: "admin/remove_extra_userType",
    active_inactive_member_Deactive: "admin/active_inactive_member",

    //FAQ
    getFaqs: "admin/faq/get",
    addFaqs: "admin/faq",
    updateFaqs: "admin/faq",
    deleteFaqs: "admin/faq",

    //Account
    getAccount: "admin/delete_reason/get",
    addAccount: "admin/delete_reason",
    updateAccount: "admin/delete_reason",
    deleteAccount: "admin/delete_reason",

    //Stage Of Claims
    getStage: "admin/stage",
    addStage: "admin/stage",
    updateStage: "admin/stage",
    deleteStage: "admin/stage",

    //Documents
    getDocuments: "admin/get_members",
    verifyDocuments: "user/update_sahaynidhi",
    getDocumentsById: "admin/get_member",
    updateMember: "admin/update_member",
    getMembersSummary: "admin/get_members_summary",

    // User & Role
    add_role_access: "admin/add_role_access",
    get_role_access: "admin/get_role_access",
    update_role_access: "admin/update_role_access",
    get_available_access: "admin/get_available_access",

    // Page Management (Sidebar Configuration)
    get_sidebar_config: "admin/get_sidebar_config",
    update_page_settings: "admin/update_page_settings",
    bulk_update_page_settings: "admin/bulk_update_page_settings",
    add_new_page: "admin/add_new_page",
    delete_page: "admin/delete_page",

    // Banner
    getBanner: "admin/banner/get",
    addBanner: "admin/banner",
    updateBanner: "admin/banner",
    deleteBanner: "admin/banner/",

    // Occupation
    getOccupation: "admin/occupation/get",
    addOccupation: "admin/occupation",
    updateOccupation: "admin/occupation",
    deleteOccupation: "admin/occupation",

    // App Version
    getAppVersion: "admin/appVersion/get?platformType=",
    updateAppVersion: "admin/appUpdateVersion",

    // App Role & Permission 
    update_application_role_permission: "admin/update_application_role_permission",

    //General Notfication
    // ---> Notification
    getNotifications: "admin/notification/get",
    addNotifications: "admin/notification",
    updateNotifications: "admin/notification",
    deleteNotifications: "admin/notification/",

    // follwUp 
    get_all_followups: "admin/get_all_followups",
    update_followup: "admin/update_followup",
    update_notInterestedStatus: "admin/update_notInterestedStatus",
    getDocumentAssigneeRoles: "admin/getDocumentAssigneeRoles",
    assignMember: "admin/assignMember",

    // getTransactionHistory
    getTransactionHistory: "admin/get_user_transaction_history",
    getParticularUserTransaction: "admin/get_user_all_transaction_status_history",
    get_transaction_list: "admin/get_transaction_list",

    // get_member_by_mobileNumber
    getMemberByMobileNumber: "admin/get_member_by_mobileNumber",


    addRole: "admin/add_role",
    deleteRole: "admin/delete_role",

    app_get_role_access: "admin/app_get_role_access",
    app_update_role_access: "admin/app_update_role_access",

    get_all_organisations: "admin/get_all_organisations",
    get_company_member_list: "admin/get_company_member_list",
    get_company_members_summary: "admin/get_company_members_summary",
    update_company_member: "admin/update_company_member",
    get_active_members: "admin/member/get_active_members",
    get_active_members_summary: "admin/member/get_active_members_summary",
    global_search: "admin/global-search",
    export_active_members: "admin/member/export_active_members",

    // Organisation CRUD
    create_organisation: "admin/create_organisation",
    get_organisations: "admin/get_organisations",
    get_organisation_by_id: "admin/get_organisation_by_id",
    update_organisation: "admin/update_organisation",
    delete_organisation: "admin/delete_organisation",
    add_organisation_admin: "admin/add_organisation_admin",
    remove_organisation_admin: "admin/remove_organisation_admin",
    get_organisation_roles: "admin/get_organisation_roles",
    create_organisation_role: "admin/create_organisation_role",

    // Bulk Import
    get_bulk_import_template: "admin/get_bulk_import_template",
    download_bulk_import_template: "admin/download_bulk_import_template",
    validate_bulk_import: "admin/validate_bulk_import",
    bulk_import_members: "admin/bulk_import_members",
    move_users_to_org: "admin/move_users_to_org",
    migrate_org_member_statuses: "admin/migrate_org_member_statuses",
    get_import_history: "admin/get_import_history",

    get_organisation_claims: "admin/get_organisation_claims",
    update_claim_stage: "admin/update_claim_stage",
    get_organisation_payment_request  : "admin/get_organisation_payment_request",
    approve_organisation_paymentRequest : "admin/approve_organisation_paymentRequest",
    create_organisation_paymentRequest : "admin/create_organisation_paymentRequest",
    add_user_transaction : "admin/add_user_transaction",
    download_transaction_receipt : "admin/download_transaction_receipt",
    check_transaction_status : "admin/check_transaction_status",
    aadhar_send_otp : "admin/aadhar_send_otp",
    aadhar_verify_otp : "admin/aadhar_verify_otp",
    id_proof_verification : "admin/id_proof_verification",
    get_payment_receipt : "admin/get_payment_receipt",
    api_config : "admin/api_config",
    update_config : "admin/update_config",
    create_posts : "admin/create_posts",
    get_posts : "admin/get_posts",
    get_post_by_id : "admin/get_post_by_id",
    delete_post : "admin/delete_post",
    update_post : "admin/update_post",
    copy_mobile_banners_to_website : "admin/copy_mobile_banners_to_website",
    reorder_hero_banners : "admin/reorder_hero_banners",
    get_core_team_options : "admin/get_core_team_options",
    create_core_team_option : "admin/create_core_team_option",
    update_core_team_option : "admin/update_core_team_option",
    delete_core_team_option : "admin/delete_core_team_option",
    createPrivacyPolicyAndTermsAndCondition : "admin/createPrivacyPolicyAndTermsAndCondition",
    getPrivacyPolicyAndTermsAndCondition : "admin/getPrivacyPolicyAndTermsAndCondition",
    get_contactUs : "admin/get_contactUs",
    delete_contactUs : "admin/delete_contactUs",
    updatePrivacyPolicyAndTermsAndCondition : "admin/updatePrivacyPolicyAndTermsAndCondition",
    getMemberByPhoneNumber : "admin/getMemberByPhoneNumber",
    getDeletedUsers : "admin/get_deleted_users",
    restoreDeletedUser : "admin/restore_deleted_user",
    permanentDeleteUser : "admin/permanent_delete_user",
    markAsDeceased : "admin/mark_as_deceased",
    markAsOptedOut : "admin/mark_as_opted_out",
    getDuplicateAccounts : "admin/get_duplicate_accounts",
    mergeDuplicateAccounts : "admin/merge_duplicate_accounts",
    getTicket : "admin/getTicket",
    getTicketById : "admin/getTicketById",
    getTicketStats : "admin/getTicketStats",
    getTicketConfig : "admin/getTicketConfig",
    updateTicket : "admin/updateTicket",
    addTicketReply : "admin/addTicketReply",
    deleteTicket : "admin/deleteTicket",
    get_members_report: "admin/get_members_report",
    getAllEligibleMembers : "admin/getAllEligibleMembers",
    getAllClaims : "admin/getAllClaims",
    updateClaim : "admin/updateClaim",
    
    // Enhanced Claims (Stage-based)
    getEnhancedClaims: "admin/claim",
    getEnhancedClaimDetails: "admin/claim/",
    moveClaimStage: "admin/claim",
    adminNotifyDeath: "admin/notify_death",
    getClaimById: "admin/getClaimById",
    
    // Reference/Referral Tracking
    getTopReferrers: "admin/reference-tracking/top-referrers",
    getReferredMembers: "admin/reference-tracking/members/",
    getReferenceStats: "admin/reference-tracking/stats",
    createaboutUs : "admin/createaboutUs",
    updateaboutUs : "admin/updateaboutUs",
    getallaboutUs : "admin/getallaboutUs",
    getallpressandmediacoverage : "admin/getallpressandmediacoverage",
    createpressandmediacoverage : "admin/createpressandmediacoverage",
    updatepressandmediacoverage : "admin/updatepressandmediacoverage",
    getallpress : "admin/getallpress",
    createpress : "admin/createpress",
    updatepress : "admin/updatepress",
    deletepress : "admin/deletepress",
    
    // SMS Gateway
    getSmsGateway: "admin/get_smsgateway",
    updateSmsGateway: "admin/update_smsgateway",
    
    // Age Wise Payment Settings
    getAgeGroup: "admin/get_agegroup",
    createAgeGroup: "admin/create_agegroup",
    updateAgeGroup: "admin/update_agegroup",
    updateSingleAgeGroup: "admin/update_single_agegroup",
    deleteAgeGroup: "admin/delete_agegroup/",

    // ==================== IMPROVEMENT APIs (v2) ====================
    
    // Stage Management
    getStages: "v2/admin/stages",
    createRegistrationStage: "v2/admin/stages",
    updateRegistrationStage: "v2/admin/stages/",
    deleteRegistrationStage: "v2/admin/stages/",
    reorderStages: "v2/admin/stages/reorder",
    transitionUserStage: "v2/admin/stages/transition",
    getUserStageProgress: "v2/admin/stages/user/",

    // Referral Management
    getReferralConfig: "v2/admin/referral/config",
    updateReferralConfig: "v2/admin/referral/config",
    getAllReferrals: "v2/admin/referral/list",
    getReferralLeaderboard: "v2/admin/referral/leaderboard",
    migrateReferrals: "v2/admin/referral/migrate",

    // System Management
    getAuditLogs: "v2/admin/system/audit-logs",
    getAuditLogDetail: "v2/admin/system/audit-log-detail",
    getActivitySummary: "v2/admin/system/activity-summary",
    getCacheStats: "v2/admin/system/cache-stats",
    clearCache: "v2/admin/system/clear-cache",
    getStatusSummary: "v2/admin/system/status-summary",
    getPaymentStats: "v2/admin/system/payment-stats",
    getSystemHealth: "v2/admin/system/health",
    triggerReminders: "v2/admin/system/trigger-reminders",
    runMigration: "v2/admin/system/run-migration",
    runSeeds: "v2/admin/system/run-seeds",
    seedSRKOrganisation: "v2/admin/system/seed-srk",
    getExpiringPolicies: "v2/admin/system/expiring-policies",

    // ==================== REMINDER MODULE APIs ====================
    getRenewalList: "admin/reminder/get_renewal_list",
    getMemberRenewalDetails: "admin/reminder/member/",
    sendWhatsAppReminder: "admin/reminder/send_whatsapp",
    sendBulkReminders: "admin/reminder/send_bulk",
    getReminderHistory: "admin/reminder/history/",
    getReminderStats: "admin/reminder/stats",
    exportRenewalList: "admin/reminder/export",
    // Renewal Template Reminders (Meta Approved WhatsApp Templates)
    getRenewalTemplates: "admin/reminder/templates",
    sendRenewalTemplateReminder: "admin/reminder/send_renewal_template",
    sendBulkTemplateReminders: "admin/reminder/send_bulk_template",

    // WhatsApp Direct Template Sending
    getWhatsAppTemplates: "admin/whatsapp/templates",
    sendWhatsAppToMember: "admin/whatsapp/send-to-member",
    testWhatsAppTemplate: "admin/whatsapp/test-template",

    // ==================== EXPENSE MODULE APIs ====================
    // Expense CRUD
    createExpense: "admin/expense/create",
    getExpenses: "admin/expense/get",
    getExpenseById: "admin/expense/",
    updateExpense: "admin/expense/update",
    deleteExpense: "admin/expense/",
    
    // Expense Approval
    approveExpense: "admin/expense/approve",
    rejectExpense: "admin/expense/reject",
    bulkApproveExpenses: "admin/expense/bulk-approve",
    bulkRejectExpenses: "admin/expense/bulk-reject",
    getPendingExpenses: "admin/expense/pending",
    
    // Expense Dashboard
    getExpenseDashboard: "admin/expense/dashboard/stats",
    
    // Expense Categories
    createExpenseCategory: "admin/expense-category/create",
    getExpenseCategories: "admin/expense-category/get",
    updateExpenseCategory: "admin/expense-category/update",
    deleteExpenseCategory: "admin/expense-category/",
    seedExpenseCategories: "admin/expense-category/seed",
    
    // Expense Reports
    getMonthlyExpenseReport: "admin/expense/report/monthly",
    getCategoryExpenseReport: "admin/expense/report/category",
    getCustomExpenseReport: "admin/expense/report/custom",
    getDailyExpenseExport: "admin/expense/export/daily",
    saveExpenseReport: "admin/expense/report/save",
    getExpenseReportHistory: "admin/expense/report/history",

    // ==================== POST GENERATOR MODULE APIs ====================
    createPostCategory: "admin/post-generator/category/create",
    getPostCategories: "admin/post-generator/category/get",
    updatePostCategory: "admin/post-generator/category/update",
    deletePostCategory: "admin/post-generator/category/",
    createPostTemplate: "admin/post-generator/template/create",
    getPostTemplates: "admin/post-generator/template/get",
    getPostTemplateById: "admin/post-generator/template/",
    updatePostTemplate: "admin/post-generator/template/update",
    deletePostTemplate: "admin/post-generator/template/",
    getPostGeneratorStats: "admin/post-generator/stats",
    seedPostCategories: "admin/post-generator/seed-categories",

    // ==================== PUBLIC WEBSITE APIs (Landing Pages) ====================
    public_getHeroBanners: "public/website/banners",
    public_getMobileHeroBanners: "public/website/mobile-banners",
    public_getEvents: "public/website/events",
    public_getEventById: "public/website/events/",
    public_getOfficeMembers: "public/website/office-members",
    public_getCoreTeamTypes: "public/website/core-team-types",
    public_getAboutUs: "public/website/about-us",
    public_getPressAndMedia: "public/website/press-and-media",
    public_getPress: "public/website/press",
    public_getPrivacyPolicy: "public/website/privacy-policy",
    public_getTermsAndConditions: "public/website/terms-and-conditions",
    public_getWebsiteStats: "public/website/stats",
    public_getFaq: "public/website/faq",
    public_submitContactUs: "public/website/contact-us",
};